export default {
  COMMON__MINUTES: 'mnt',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: 'Edit',
    BUTTON__DELETE: 'Hapus',
    MESSAGE_STATUS__DELETE: 'Hapus',
    MESSAGE_MENU__DELETE: 'Hapus',
    BUTTON__SAVE: 'Simpan',
    BUTTON__CANCEL: 'Batal',
    BUTTON__CLOSE: 'Tutup',
    MODAL__CHANNEL_INFORMATION__UPLOAD: 'Unggah',
    EDIT_PROFILE__IMAGE_UPLOAD: 'Unggah',
    CHANNEL_LIST__TITLE: 'Kanal',
    CHANNEL_SETTING__HEADER__TITLE: 'Info kanal',
    MODAL__USER_LIST__TITLE: 'Anggota',
    CHANNEL_SETTING__MEMBERS__TITLE: 'Anggota',
    NO_MEMBERS: '(Tidak ada anggota)',
    NO_NAME: '(Tanpa nama)',
    TOOLTIP__UNKOWN_USER: '(Tanpa nama)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: 'Tinggalkan kanal',
    BUTTON__INVITE: 'Undang',
    MODAL__INVITE_MEMBER__SELECTED: 'Dipilih',
    MODAL__CREATE_CHANNEL__SELECTED: 'Dipilih',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: 'Nama kanal',
    MODAL__INVITE_MEMBER__TITLE: 'Undang anggota',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: 'Masuk',
    MESSAGE_INPUT__PLACE_HOLDER: 'Masuk',
    BUTTON__CREATE: 'Buat',
    MODAL__CREATE_CHANNEL__TITLE: 'Kanal baru',
    TRYING_TO_CONNECT: 'Mencoba menghubungkan...',
    USER_PROFILE__MESSAGE: 'Pesan',
    USER_PROFILE__USER_ID: 'ID Pengguna',
    EDIT_PROFILE__USERID_LABEL: 'ID Pengguna',
    EDIT_PROFILE__TITLE: 'Profil saya',
    EDIT_PROFILE__IMAGE_LABEL: 'Gambar profil',
    EDIT_PROFILE__NICKNAME_LABEL: 'Nama panggilan',
    EDIT_PROFILE__THEME_LABEL: 'Tema gelap',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: 'Obrolan tidak tersedia di kanal ini',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: 'pesan baru sejak',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: 'pada',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: 'Semua anggota',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: 'Undang pengguna',
    MODAL__DELETE_MESSAGE__TITLE: 'Hapus pesan ini?',
    MODAL__CHANNEL_INFORMATION__TITLE: 'Edit informasi kanal',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: 'Gambar kanal',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: 'Masukkan nama',
    TYPING_INDICATOR__IS_TYPING: 'sedang mengetik...',
    TYPING_INDICATOR__ARE_TYPING: 'sedang mengetik...',
    TYPING_INDICATOR__MULTIPLE_TYPING: 'sedang mengetik...',
    TYPING_INDICATOR__AND: 'dan',
    MESSAGE_STATUS__SENDING_FAILED: 'Tidak dapat mengirim pesan.',
    MESSAGE_STATUS__TRY_AGAIN: 'Coba lagi',
    MESSAGE_STATUS__OR: 'atau',
    PLACE_HOLDER__WRONG: 'Terjadi kesalahan.',
    PLACE_HOLDER__RETRY_TO_CONNECT: 'Coba lagi',
    NO_TITLE: 'Tanpa judul',
    TOOLTIP__AND_YOU: ', dan Anda',
    TOOLTIP__YOU: 'Anda',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(Jenis pesan tidak diketahui)',
    UNKNOWN__CANNOT_READ_MESSAGE: 'Tidak dapat membaca pesan ini.',
    MESSAGE_EDITED: '(diedit)',
    PLACE_HOLDER__NO_CHANNEL: 'Mulai percakapan baru',
    MESSAGE_MENU__REPLY: 'Balas',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: 'Anda',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: 'Balas pesan',
    CHANNEL_SETTING__PROFILE__EDIT: 'Edit',
    MESSAGE_MENU__COPY: 'Salin',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: 'OK',
  SETTINGS__NONE: 'Tidak ada',
  SEARCH__USER_PLACEHOLDER: 'Nama/No. Karyawan/No. Telepon',
  SEARCH__NO_USER_INFO: 'Tidak ada info pengguna.',
  LOGIN__EMAIL_OR_HP: 'Email atau No. telepon',
  ELECTRON: {
    MENU_DELETE: 'Hapus',
    MENU_VIEW: 'Lihat',
    MENU_SIGN_OUT: 'Keluar',
    MENU_SETTINGS: 'Pengaturan',
    MENU_CLOSE: 'Tutup',
    MENU_SELECT_ALL: 'Pilih semua',
    MENU_FILE: 'File',
    MENU_ABOUT: 'Tentang {0}',
    MENU_UPDATE: 'Periksa pembaruan',
    MENU_HIDE: 'Sembunyikan {0}',
    MENU_HIDE_OTHERS: 'Sembunyikan lainnya',
    MENU_SHOW_ALL: 'Tampilkan semua',
    MENU_QUIT: 'Keluar dari {0}',
    MENU_NEW_CHANNEL: 'Kanal baru',
    MENU_UNDO: 'Urungkan',
    MENU_REDO: 'Ulangi',
    MENU_CUT: 'Potong',
    MENU_PASTE: 'Tempel',
    MENU_PASTE_AND_MATCH_STYLE: 'Tempel gaya',
    MENU_RELOAD: 'Muat ulang',
    MENU_FORCE_RELOAD: 'Paksa muat ulang',
    MENU_FULL_SCREEN: 'Alihkan layar penuh',
    MENU_RESET_ZOOM: 'Ukuran asli',
    MENU_ZOOM_IN: 'Perbesar',
    MENU_ZOOM_OUT: 'Perkecil',
    MENU_WINDOW: 'Jendela',
    MENU_MINIMIZE: 'Perkecil jendela',
    MENU_ZOOM: 'Perbesar',
    MENU_HELP: 'Bantuan',
    MESSAGE_UP_TO_DATE: 'Anda saat ini menggunakan versi terbaru.',
    UPDATE_AVAILABLE: 'Pembaruan tersedia',
    MESSAGE_UPDATE_AVAILABLE: 'Pembaruan ke versi terbaru tersedia.',
    MENU_EDIT: 'Edit',
    MENU_COPY: 'Salin',
    UP_TO_DATE: 'Versi terbaru',
  },
  LOGIN__INSERT_EMAIL_HP: 'Masukkan email atau no. telepon Anda',
  LOGIN__PASSWORD_GUIDE_SUBTITLE: 'Jika Anda lupa kata sandi, silakan reset di halaman login aplikasi seluler.',
  LOGIN__INSERT_PASSWORD: 'Silakan masukkan kata sandi',
  LOGIN__PASSWORD_INFORMATION: 'Lupa kata sandi Anda?',
  BEFORE: 'Sebelum',
  ALERT__NO_ONE_SELECTED: 'Tidak ada yang dipilih.',
  BASIC__: {
    ERROR: 'Terjadi kesalahan. <br /> Silakan coba lagi nanti.',
    MSG__: { INPUT: 'Cari berdasarkan kata kunci' },
    PWD_ALL_VALIDATION: 'Kata sandi harus berupa kombinasi huruf besar/kecil, angka, dan karakter khusus %1$@~%2$@.',
    RETRY: 'Coba lagi',
    PASSWORD_RULE: '8–20 karakter dan harus mengandung huruf, angka, dan simbol.',
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: 'Wewenang untuk melihat riwayat kehadiran pribadi',
  },
  LOGOUT: 'Keluar',
  COMMON__SECONDS: 'Detik',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: 'Jika Anda menghentikan pengeditan, perubahan yang belum disimpan akan hilang.',
      ARE_YOU_SURE_WANT_TO_STOP: 'Apakah Anda yakin ingin menghentikan pengeditan jadwal?',
    },
  },
  TEMPLATE__: { GUIDE__: { NO_TEMPLATE_REGISTERED: 'Tidak ada template yang terdaftar.' } },
  AWAY_TIME: 'j',
  SETTINGS__CHANGE_LANGUAGE: 'Bahasa',
  SEARCH__MEMBER_PLACEHOLDER: 'Nama/No. karyawan/No. telepon',
  ' ': "Jika diatur ke 'Jangan gunakan', fitur manajemen kehamilan/pasca-melahirkan akan dinonaktifkan dan Anda tidak dapat melihat catatan terkait.",
  BASIC__UNKNOWN: 'Tidak diketahui',
  LOGIN__SERVER_ALERT: 'Tidak dapat terhubung ke server.',
  MSG__: {
    ERROR__: {
      UPDATE_CHANNEL_INFO: 'Tidak dapat memperbarui kanal.',
      LEAVE_CHANNEL: 'Tidak dapat keluar dari kanal.',
      CREATE_CHANNEL: 'Tidak dapat membuat channel.',
    },
    FILE__: { MAXIMGSIZE: 'Melebihi batas ukuran file.' },
    ALLOW_BROWSER_ALARM: 'Izinkan notifikasi di pengaturan browser Anda untuk menerima pesan notifikasi.',
    LABEL__: { SEARCH_MESSAGE: 'Cari pesan' },
    GUIDE__: { SEARCH_MESSAGE: 'Cari pesan yang ingin Anda temukan di {0}.' },
    BASIC__: { NO_SEARCH_RESULT: 'Tidak ada hasil ditemukan.' },
  },
  INVITE__MEMBER_SELECTION: 'Pilih anggota',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: 'Nama yang diubah akan terlihat oleh semua peserta kanal.',
  NOTICE: 'Notifikasi',
  INVITE__CREATE: 'Buat',
  CHANNEL__LEAVE_THIS_CHANNEL: 'Tinggalkan kanal?',
  LOGIN__PASSWORD_FAIL_COUNT: 'Anda telah memasukkan kata sandi yang salah sebanyak {0} kali.',
  LOGIN__FAIL_ALERT: 'Akun akan terkunci selama 5 menit setelah 5 kali percobaan salah berturut-turut.',
  LOGIN__LOCK_STATE_ALERT: 'Terkunci selama 5 menit karena percobaan kata sandi salah berturut-turut.',
  LOGIN__RETRY_ALERT: 'Silakan coba lagi dalam {0}.',
  LOGIN__PASSWORD_GUIDE_TITLE: 'Kata sandi ShoplChat sama dengan kata sandi aplikasi mobile.',
  SETTINGS__ALL_MESSAGES: 'Notifikasi pada semua pesan baru',
  SETTINGS__ALARM_SOUND: 'Suara',
  SETTINGS__SOUND_ALARM: 'Suara notifikasi',
  SETTINGS__LISTEN_ALARM_SOUND: 'Dengarkan',
  ALERT__MAX_INVITE_MEMBER: 'Jumlah maksimum orang yang dapat bergabung ke kanal adalah 20.000.',
  LOGIN__DEACTIVATED_ALERT: 'Tidak dapat masuk karena administrator menonaktifkan fitur obrolan.',
  LOGIN__SERVER_ALERT_CONTENTS:
    'Tidak dapat masuk karena jaringan tidak stabil. Silakan periksa koneksi jaringan lalu coba lagi.',
  LOGIN__LOGOUT_ALERT: 'Anda telah keluar.',
  CHANNEL__EDIT_CHANNEL_NAME: 'Ubah nama kanal',
  SETTINGS__THEME: 'Tema',
  SETTINGS__LANGUAGE: 'Bahasa',
  SETTINGS__LIGHT_THEME: 'Terang',
  SETTINGS__DARK_THEME: 'Gelap',
  SEARCH__CHANNEL_PLACEHOLDER: 'Nama karyawan',
  CHANNEL__CONTACT: 'Obrolan 1:1',
  BASIC: { LABEL: { MAXIMAGECNT: 'Hingga {0} gambar dapat diunggah.' } },
  LOGIN__LOGIN_FAILED: 'ID atau kata sandi salah.',
  FORGOT_PW: 'Lupa kata sandi Anda?',
  BASIC__MAX_FORMAT_INPUT: 'Maks. %@ karakter dapat dimasukkan.',
  SERVICE__COMING_SOON: 'Segera hadir',
  LOGIN__GUIDE: 'Anda dapat masuk dengan akun yang digunakan di aplikasi.',
  MOBILE__: {
    ACCESS_PC: 'Akses Dashboard dari PC!',
    ACCESS_DESC_01: 'Dashboard dioptimalkan untuk lingkungan PC.',
    ACCESS_DESC_02: 'Cobalah akses dari PC untuk pengalaman terbaik.',
    ACCESS_PC_ONLY: 'Coba akses dari PC.',
    GUIDE: 'Fitur chat tersedia di PC atau aplikasi seluler Anda.',
  },
  CHANNEL__NO_CHAT_HISTORY: 'Tidak ada percakapan',
  LOGIN: 'Masuk',
  LOGIN__PASSWORD: 'Kata sandi',
  SEARCH__NO_RESULT: 'Tidak ada hasil ditemukan.',
  BASIC__SEARCH: 'Cari',
};
